// extracted by mini-css-extract-plugin
export default {"manageUserGroup":"ManageGroup_manageUserGroup__hkURH","groupNameText":"ManageGroup_groupNameText__PIF0S"};